// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"xGAVV","cardTitle":"pmuFp","cardItem":"_38gAX","cardItemCover":"_6-t86","cardItemTitle":"_1PGzc","cardItemValue":"KK8Mz"};